import React from "react";
import "./privacypolicy.css";
export default function PrivacyPolicy() {
  return (
    <div>
      <div className="privacy__main">
        <div className="privay__first">
        <h1>Privacy Policy</h1>
        <p className="privacy__p">
          Lofty Dreams Recliners take privacy policy exceptionally truly and we
          set the most elevated measures in this respect. We esteem the belief
          you put in us. It would be ideal if you studied this archive with
          respect to our protection arrangement.
        </p>
        <h3>How do Lofty Dreams utilize customer or user information?</h3>

        <p className="privacy__p">
          We just gather customer or user information as required to lead our
          business and to empower us to give the finest services to our
          customers and users. We don’t sell or rent this information to
          outsiders.
        </p>
        </div>
        <div className="privacy__second">
        <h5>
          {" "}
          Customer or User information (as defined above) will be used as
          described below:-
        </h5>
        <ol start="1">
          <li>
             Customer and User data will be sharable with our auxiliaries,
            associates, and accomplices which are additionally engaged with
            conveying the service to you as a customer in your purchasing
            process.We will likewise need to share a few or the entirety of your
            data as administered on account of acquisitions by or mergers with
            different business entities.
          </li>
          <li>
            We use some of the user and customer information characterized above
            to understand customer behavior and consequently offer better and
            more relevant experiences to you. We use certain information in
            collected form across users to compile statistically and
            demographical profiles for our business and advertising activities.
          </li>
          <li>
            We use this information to inform you about offers and deals, new
            products, information about products you have bought, order and
            shipping status, as well as other promotional and informational
            content. We can use this information to communicate about our
            special offers also.
          </li>
          <li>
            Cookies would be used to give a customized experience to our
            customers, for example, distinguishing recently viewed items
            (important to the customer) just as actualizing a list of things to
            get and cart features.
          </li>
          <li>
            We use session log and traffic stream information to see how
            customers are associating with our site and to make improvements.
            This will likewise be used by us to comprehend and analyze
            customers’ inclinations, purchasing behaviors, and conduct at a
            total level.
          </li>
          <li>
            We use IP address, traffic sources, user route over the site,
            browser and Operating System Information, etc. to measure overall
            site performance in terms of a number of users, user engagement,
            time spent by users on the site, etc.
          </li>
          <li>
            We will need to use customer or user information in case that
            required in perspectives, for example, legitimate questions or other
            lawful master forms; conform to any legal or administrative
            necessity; investigate issues; distinguish and ensure against
            mistake,extortion and other crook or criminal behavior; gather
            expenses owed; uphold our terms and conditions; forestall
            maltreatment of our administrations; forestall infringement of the
            privileges of outsiders, different users, or the general public.
          </li>
          <li>
            www.loftydreamsrecliners.com gives all customers the opportunity to
            quit getting unnecessary communications from us for our accomplices,
            and from us in general, after setting up an account. To delete your
            contact data from loftydreamsrecliners.com, please write an E-Mail
            to us at loftydreams18@gmail.com
          </li>
          <li>
            Note:- User-generated content on the website shared by the user by
            means of surveys, blogs, online chat or messages, conversation
            sheets, forums, testimonials, and so on are not considered as
            personal information and aren’t subject to the terms of this privacy
            policy.
          </li>
        </ol>
        </div>
      </div>
    </div>
  );
}
